import { defineStyle as i, defineStyleConfig as C } from "@chakra-ui/react";
import { cssVar as n, getColor as e } from "@chakra-ui/theme-tools";
const f = n("skeleton-start-color"), b = n("skeleton-end-color"), u = i((a) => {
  const l = "gray.400", s = "gray.100", { startColor: c = l, endColor: d = s, theme: o } = a, t = e(o, c), r = e(o, d);
  return {
    [f.variable]: t,
    [b.variable]: r,
    opacity: 0.7,
    borderRadius: "base",
    borderColor: t,
    background: r
  };
}), m = C({
  baseStyle: u
});
export {
  m as default
};
